


/* Single image */
import simg1 from '../images/service-single/1.jpg'
import simg2 from '../images/service-single/2.jpg'
import simg3 from '../images/service-single/3.jpg'
import simg4 from '../images/service-single/4.jpg'

/* icon image */
import icon1 from '../images/service/1.svg'
import icon2 from '../images/service/2.svg'
import icon3 from '../images/service/3.svg'
import icon4 from '../images/service/4.svg'


const Services = [
    {
        id: 1,
        icon: icon1,
        simage: simg1,
        title: 'Over Night Care',
        description: 'If you are away for the night, we can keep your favorite pet happy and safe.',
        slug: 'Over-Night-Care'
    },
    {
        id: 4,
        icon: icon2,
        simage: simg2,
        title: 'Pet Walking',
        description: 'If you are away for the night, we can keep your favorite pet happy and safe.',
        slug: 'Pet-Walking'
    },
    {
        id: 3,
        icon: icon3,
        simage: simg3,
        title: 'Pet Grooming',
        description: 'If you are away for the night, we can keep your favorite pet happy and safe.',
        slug: 'Pet-Grooming'
    },
    {
        id: 4,
        icon: icon4,
        simage: simg4,
        title: 'Vaccination',
        description: 'If you are away for the night, we can keep your favorite pet happy and safe.',
        slug: 'Vaccination'
    },


];
export default Services;